<template>
    <router-view />
    <LayoutAlerts v-model="messages" />
    <vModalLayouts />
</template>

<script>
import { LayoutAlerts } from "@easy/ui/layouts";
import { mapState } from "vuex";
import vModalLayouts from "@/shared/views/vModalLayouts.vue";
import { mapMutations } from "vuex";
import { useAsyncVuexModules } from "@/store/useAsyncVuexModules";
import sharedViewModule from "@/views/store/shared-view.store";
import { usePreviewLanguage } from "@/shared/utils/router/usePreviewLanguage";
import { useRenderPreviewStore } from "@/views/store/render-preview.store";

import("@easy/ui/style.css");

/**
 * TODO: in future
 * We should provide "slimmed" vuex only with `alert` module for all routes in RENDER logic !!!
 * */

export default {
    name: "RenderMain",
    components: { vModalLayouts, LayoutAlerts },
    computed: {
        ...mapState("alert", ["messages"]),
    },
    setup() {
        useAsyncVuexModules(["shared/view", sharedViewModule]);
        const { setLanguageFromQuery } = usePreviewLanguage();
        const { setIsPreview } = useRenderPreviewStore();
        setIsPreview(false);
        setLanguageFromQuery();
    },
    mounted() {
        this.setPreview(false);
    },
    methods: {
        ...mapMutations("shared/view", ["setPreview"]),
    },
};
</script>
